import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import { Shield } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminSetup({ onSetupComplete }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/setup`, { email, password });
      toast.success('Admin-Konto erfolgreich erstellt!');
      onSetupComplete(response.data.user, response.data.access_token);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Fehler beim Erstellen des Admin-Kontos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <Shield className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-3xl font-bold font-outfit text-slate-900 mb-2">Admin Setup</h1>
          <p className="text-slate-600">Erstelle das erste Admin-Konto</p>
        </div>

        <Card className="border-slate-100 shadow-xl rounded-2xl">
          <CardHeader>
            <CardTitle className="font-outfit">Admin-Konto erstellen</CardTitle>
            <CardDescription>Dies ist nur beim ersten Setup nötig</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="admin@uniside.at"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="h-12 rounded-xl"
                  data-testid="admin-email-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Passwort</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="h-12 rounded-xl"
                  data-testid="admin-password-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full h-12 rounded-full bg-primary hover:bg-primary/90 shadow-lg"
                disabled={loading}
                data-testid="create-admin-button"
              >
                {loading ? 'Erstelle...' : 'Admin-Konto erstellen'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
